module.exports = __webpack_public_path__ + "img/type1-bg3.b9aa281f.png";